module.exports = __webpack_public_path__ + "media/images/logos/03-68fc94096b6afa86bd59d2c21be3cbbd.png";